var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHandPalm = function SvgIconHandPalm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.75 7.761V4.875a2.875 2.875 0 0 0-3.99-2.65 2.875 2.875 0 0 0-5.51 1.15v.261A2.874 2.874 0 0 0 3.5 6.375v7.875a8.5 8.5 0 0 0 17 0V10.5a2.875 2.875 0 0 0-3.75-2.739M10.125 2.5a.875.875 0 0 0-.875.875V10.5a1 1 0 1 1-2 0V6.375a.875.875 0 0 0-1.75 0v7.875a6.5 6.5 0 0 0 13 0V10.5a.875.875 0 0 0-1.75 0v1.875a1 1 0 0 1-1 1 2.75 2.75 0 0 0-2.75 2.75 1 1 0 1 1-2 0 4.75 4.75 0 0 1 3.75-4.644V4.875a.875.875 0 0 0-1.75 0V9.75a1 1 0 1 1-2 0V3.375a.875.875 0 0 0-.875-.875",
    clipRule: "evenodd"
  })));
};
export default SvgIconHandPalm;